import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { deleteBrainSimulation, exportBrainSimulationConversationsToDatasets, getBrainSimulation, queryBrainSimulations, runSimulationFromPreset } from '@wix/ambassador-individual-scheduling-assistant-v1-brain-simulation/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { BrainSimulationClientBase } from './BrainSimulationClientBase';
export class BrainSimulationClient extends HttpBaseClient(BrainSimulationClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getBrainSimulationImpl", getBrainSimulation);
    _defineProperty(this, "deleteBrainSimulationImpl", deleteBrainSimulation);
    _defineProperty(this, "queryBrainSimulationsImpl", queryBrainSimulations);
    _defineProperty(this, "exportBrainSimulationConversationsToDatasetsImpl", exportBrainSimulationConversationsToDatasets);
    _defineProperty(this, "runSimulationFromPresetImpl", runSimulationFromPreset);
  }
}
//# sourceMappingURL=BrainSimulationClientHttp.js.map